import { useEffect, useState, useRef, useMemo, useContext } from "react";
import { MonitoreoService } from "../../service/monitoreo/MonitoreoService";
import { Dropdown } from "primereact/dropdown";
import { Toolbar } from "primereact/toolbar";
import { Button } from "primereact/button";
import { NivelPerfil } from "../../models/monitoreo/NivelPerfil";
import { confirmDialog } from "primereact/confirmdialog";
import { OverlayPanel } from "primereact/overlaypanel";
import { Card } from "primereact/card";
import { ProgressSpinner } from "primereact/progressspinner";
import { ConfirmDialogPersonalizado } from "../../components/ConfirmDialogPersonalizado";
import { Tag } from "primereact/tag";
import { RadioButton } from "primereact/radiobutton";
import { Divider } from "primereact/divider";
import { useForm } from "react-hook-form";
import { TablaRiesgos as TablaRiesgosClass } from "../../models/monitoreo/TablaRiesgos";
import { useLazyParams } from "../../hooks/useLazyParams";
import { TablaDinamica } from "../../components/TablaDinamica";
import { Column } from "primereact/column";
import { RiesgoPerfilContext } from "./RiesgoPerfil";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.addVirtualFileSystem(pdfFonts);

export const TablaRiesgos = ({ matriz, permss, funcionalidades, toast, generic, regresar }) => {
    const { nivelesRiesgo, nivelesAlerta, procedimientosControl, justificaciones } = useContext(RiesgoPerfilContext);
    const RiesgosModelInstancia = useMemo(() => new TablaRiesgosClass(), []);
    const tablaEstado = useLazyParams({ modelo: RiesgosModelInstancia.model });
    const [expandedRows, setExpandedRows] = useState(null); // Controla visualmente qué filas se abren
    const { setError } = useForm();
    const monitoreoService = new MonitoreoService();
    const [loadExcel, setLoadExcel] = useState(false);
    const [loadPdf, setLoadPdf] = useState(false);
    const [loadingToolbar, setLoadingToolbar] = useState(true);
    const omodel = new NivelPerfil();
    const overlayRecomendado = useRef(null);
    const overlayAplicado = useRef(null);
    const overlayJustifacion = useRef(null);
    const [estadoMatriz, setEstadoMatriz] = useState(null);
    const [tipoActualizacion, setTipoActualizacion] = useState('visibles');
    const [comentarioEnEdicion, setComentarioEnEdicion] = useState(null);
    const [refrescarDatosHijo, setRefrescarDatosHijo] = useState(0);

    const ESTADOS = { BORRADOR: 'BORRADOR', ENVIADO: 'ENVIADO', FINALIZADO: 'FINALIZADO' };

    useEffect(() => {
        loadLazyData();
        // eslint-disable-next-line
    }, [tablaEstado.lazyParams]);

    const opcionesJustificacion = useMemo(() => justificaciones.map(j => ({ label: j.nombre, value: j.cat_id })), [justificaciones]);
    const opcionesControl = useMemo(() => procedimientosControl.map(p => ({ label: p.nombre, value: p.cat_id })), [procedimientosControl]);
    const nivelesDeRiesgoOptions = useMemo(() => nivelesRiesgo.map(r => ({ label: r.nombre, value: r.sigla, back_color: r.color_bg })), [nivelesRiesgo]);
    const nivelesDeAlertaOptions = useMemo(() => nivelesAlerta.map(a => ({ label: a.nombre, value: a.sigla, back_color: a.color_bg })), [nivelesAlerta]);

    const catalogosTabla = { riesgos: nivelesDeRiesgoOptions, alertas: nivelesDeAlertaOptions, procedimientos: opcionesControl, justificaciones: opcionesJustificacion };

    const loadLazyData = () => {
        const params = {
            ...tablaEstado.lazyParams,
            matrizId: matriz.id
        };
        tablaEstado.setLoading(true);
        monitoreoService.listado('monitoreo/nivel-riesgo-perfil/lista-matriz', { lazyEvent: JSON.stringify(params) }).then(res => {
            tablaEstado.setTotalRecords(res.data.total);
            tablaEstado.setData(res.data.registros);
            setEstadoMatriz(res.data.estado_matriz);
        }).catch(error => {
            generic.funcErrorHibrida(error, toast, setError);
        }).finally(() => {
            tablaEstado.setLoading(false);
            setLoadingToolbar(false);
        });
    }

    const rowExpansionTemplate = (rowData) => {
        return <TablaRiesgoHistorial rowData={rowData} matriz={matriz} monitoreoService={monitoreoService} toast={toast}
            generic={generic} setError={setError} catalogosTabla={catalogosTabla} estadoMatriz={estadoMatriz}
            refreshTrigger={refrescarDatosHijo} ESTADOS={ESTADOS} />;
    };

    const leftTool = () => {
        return (
            <>
                <Button onClick={() => regresar()} className="p-button-primary mr-2" icon="pi pi-arrow-left" tooltip="Regresar" tooltipOptions={{ position: 'top' }} disabled={loadExcel || loadPdf} raised />
                {estadoMatriz !== ESTADOS.FINALIZADO && (
                    <>
                        <Button icon="pi pi-file" className="mr-2" severity="secondary" rounded onClick={(e) => overlayRecomendado.current.toggle(e)} tooltip="Actualizar: Procedimiento recomendado" tooltipOptions={{ position: 'top' }} raised />
                        <Button icon="pi pi-file-edit" className="mr-2" severity="info" rounded onClick={(e) => overlayAplicado.current.toggle(e)} tooltip="Actualizar: Procedimiento aplicado" tooltipOptions={{ position: 'top' }} raised />
                        <Button icon="pi pi-file-import" className="mr-2" severity="help" rounded onClick={(e) => overlayJustifacion.current.toggle(e)} tooltip="Actualizar: Justificación" tooltipOptions={{ position: 'top' }} raised />
                    </>
                )}
            </>
        );
    };

    const siOpcion = (key) => {
        return permss?.actualizar && (funcionalidades.includes('PRELAFIT') || funcionalidades.includes(key));
    };

    const rightTool = () => {
        return (
            <div className="flex justify-content-end gap-4">
                <div className="flex gap-2">
                    <Button onClick={() => exportar('pdf')} className="p-button-danger" title="Generar en formato PDF" tooltip="Descargar Reporte PDF" tooltipOptions={{ position: 'top' }} icon="pi pi-file-pdf" loading={loadPdf} disabled={loadExcel} raised />
                    <Button onClick={() => exportar('xlsx')} className="p-button-success" title="Generar en formato Excel" tooltip="Descargar Reporte Excel" tooltipOptions={{ position: 'top' }} icon="pi pi-file-excel" loading={loadExcel} disabled={loadPdf} raised />
                    {permss?.actualizar && estadoMatriz === ESTADOS.BORRADOR && siOpcion("monitoreo-perfil-boton-finalizar") && (
                        <Button onClick={handleFinalizarMonitoreo} className="p-button-info" title="Finalizar Monitoreo" icon="pi pi-check" disabled={loadExcel || loadPdf} label="FINALIZAR MATRIZ" />
                    )}
                    {permss?.actualizar && estadoMatriz === ESTADOS.FINALIZADO && siOpcion("monitoreo-perfil-boton-borrador") && (
                        <Button onClick={handleVolverABorrador} className="p-button-secondary" title="Volver a Borrador" icon="pi pi-refresh" disabled={loadExcel || loadPdf} label="VOLVER A BORRADOR" />
                    )}
                </div>
            </div>
        );
    };

    const confirmarBulkChange = (tipo, label, nuevoValor, tipoActualizacion) => {
        const cantidadVisibles = tablaEstado.data?.length || 0;
        const campo = {
            justificacion: 'la justificación',
            recomendado: 'el procedimiento recomendado',
            aplicado: 'el procedimiento aplicado',
        };
        const mensaje =
            tipoActualizacion === 'visibles'
                ? (
                    <span>
                        ¿Estás seguro de aplicar {campo[tipo]} <strong>{label}</strong> a <strong>todos los registros visibles ({cantidadVisibles})</strong>?
                    </span>
                )
                : (
                    <span>
                        <strong>Atención:</strong> Esto aplicará {campo[tipo]} <strong>{label}</strong> en <strong>TODOS los registros (visibles y no visibles)</strong>.
                        <br />¿Desea continuar?
                    </span>
                );

        confirmDialog({
            group: 'justificacion-bulk',
            header: 'Confirmar Cambio Masivo',
            message: {
                texto: mensaje,
                valores: nuevoValor,
                tipo: tipo,
                tipoActualizacion: tipoActualizacion,
            },
            defaultFocus: 'accept',
        });
    };

    const exportar = (tipo) => {
        setLoadExcel(tipo === 'xlsx');
        setLoadPdf(tipo === 'pdf');
        if (tipo === 'xlsx') {
            monitoreoService.generar('monitoreo/nivel-riesgo-perfil/reporte', tipo, matriz?.id).then(res => {
                generic.downloadPdf(res.data, 'Reporte_Monitoreo_Nivel_Riesgo_Perfil.' + tipo);
            }).catch(error => {
                generic.funcErrorHibrida(error, toast, setError);
            }).finally(() => {
                setLoadExcel(false);
                setLoadPdf(false);
            });
        } else {
            monitoreoService.consultar(matriz?.id, `monitoreo/nivel-riesgo-perfil/reporte/${tipo}`).then(res => {
                generarDetalle(res.data.detalle, res.data.info);
            }).catch(error => {
                generic.funcErrorHibrida(error, toast, setError);
            }).finally(() => {
                setLoadExcel(false);
                setLoadPdf(false);
            });
        }
    }

    const valueCell = (renderRow, rowspan, value, color = null) => {
        const res = { text: value || '', alignment: 'center' };
        if (!renderRow) {
            res.text = '';
            return res;
        }
        if (rowspan > 1) {
            res.rowSpan = rowspan;
            res.verticalAlignment = 'middle';
        }
        if (color) res.fillColor = color.startsWith('#') ? color : '#' + color;
        return res;
    }

    const generarDetalle = (detalles, info) => {
        const conteoAgrupacion = {};
        detalles.forEach(row => {
            const id = row.identificacion;
            conteoAgrupacion[id] = (conteoAgrupacion[id] || 0) + 1;
        });

        let body = [
            [
                { text: 'Nombre / Razón Social', style: 'th', rowSpan: 2, verticalAlignment: 'middle' },
                { text: 'Identificación', style: 'th', rowSpan: 2, verticalAlignment: 'middle' },
                { text: 'Fecha', style: 'th', rowSpan: 2, verticalAlignment: 'middle' },
                { text: 'Factores Matriz de Cliente', style: 'th', colSpan: 4, verticalAlignment: 'middle' }, {}, {}, {}, // colspan 4
                { text: 'Desviaciones de Factores', style: 'th', colSpan: 5, verticalAlignment: 'middle' }, {}, {}, {}, {}, // colspan 5
                { text: 'Alerta Factores', style: 'th', rowSpan: 2, verticalAlignment: 'middle' },
                { text: 'Riesgo Inherente', style: 'th', colSpan: 4, verticalAlignment: 'middle' }, {}, {}, {}, // colspan 4
                { text: 'Procedimientos de Control', style: 'th', colSpan: 3, verticalAlignment: 'middle' }, {}, {}, // colspan 3
                { text: 'Riesgo Residual', style: 'th', colSpan: 4, verticalAlignment: 'middle' }, {}, {}, {}, // colspan 4
                { text: 'Alerta Consolidada', style: 'th', rowSpan: 2, verticalAlignment: 'middle' },
                { text: 'Justificación', style: 'th', rowSpan: 2, verticalAlignment: 'middle' },
                { text: 'Comentario', style: 'th', rowSpan: 2, verticalAlignment: 'middle' }
            ],
            [
                {}, {}, {},
                { text: 'Cliente', style: 'th', verticalAlignment: 'middle' }, // Factores Matriz de Cliente
                { text: 'Producto', style: 'th', verticalAlignment: 'middle' },
                { text: 'Transacción', style: 'th', verticalAlignment: 'middle' },
                { text: 'Factor Acelerador', style: 'th', verticalAlignment: 'middle' },
                { text: 'Cliente', style: 'th', verticalAlignment: 'middle' }, // Desviaciones de Factores
                { text: 'Producto', style: 'th', verticalAlignment: 'middle' },
                { text: 'Transacción', style: 'th', verticalAlignment: 'middle' },
                { text: 'Acelerador', style: 'th', verticalAlignment: 'middle' },
                { text: 'Promedio', style: 'th', verticalAlignment: 'middle' },
                {}, // rowspan: Alerta Factores
                { text: 'Calificación', style: 'th', verticalAlignment: 'middle' }, // Riesgo Inherente
                { text: 'Nivel', style: 'th', verticalAlignment: 'middle' },
                { text: 'Alerta Apetito', style: 'th', verticalAlignment: 'middle' },
                { text: 'Alerta Tolerancia', style: 'th', verticalAlignment: 'middle' },
                { text: 'Recomendado', style: 'th', verticalAlignment: 'middle' }, // Procedimientos de Control
                { text: 'Aplicado', style: 'th', verticalAlignment: 'middle' },
                { text: 'Alerta Procedimiento Aplicado', style: 'th', verticalAlignment: 'middle' },
                { text: 'Calificación', style: 'th', verticalAlignment: 'middle' }, // Riesgo Residual
                { text: 'Nivel', style: 'th', verticalAlignment: 'middle' },
                { text: 'Alerta Apetito', style: 'th', verticalAlignment: 'middle' },
                { text: 'Alerta Tolerancia', style: 'th', verticalAlignment: 'middle' },
                {}, {}, {} // rowspan: Alerta Consolidada, Justificación, Comentario
            ]
        ];

        const procesados = {};

        detalles.forEach(row => {
            const id = row.identificacion;
            let esPrimeraFila = false;
            let rowspan = 1;

            if (!procesados[id]) {
                esPrimeraFila = true;
                rowspan = conteoAgrupacion[id];
                procesados[id] = true;
            }

            // Atajo para las celdas simples (sin merge)
            const celdaNormal = (valor, color = null) => valueCell(true, 1, valor, color);

            body.push([
                valueCell(esPrimeraFila, rowspan, row.nombres),
                valueCell(esPrimeraFila, rowspan, row.identificacion),
                celdaNormal(row.fecha),
                // valores atriz
                celdaNormal(row.cliente),
                celdaNormal(row.producto),
                celdaNormal(row.transaccion),
                celdaNormal(row.factor_acelerador),

                // Desviaciones
                valueCell(esPrimeraFila, rowspan, row.desviacion_factor_cliente),
                valueCell(esPrimeraFila, rowspan, row.desviacion_factor_producto),
                valueCell(esPrimeraFila, rowspan, row.desviacion_factor_transaccion),
                valueCell(esPrimeraFila, rowspan, row.desviacion_factor_acelerador),
                valueCell(esPrimeraFila, rowspan, row.promedio_desviacion),

                // Alerta Factores
                valueCell(esPrimeraFila, rowspan, row.af_alerta_factor, row.af_alerta_color),

                celdaNormal(row.calificacion_riesgo_inherente),
                celdaNormal(row.nri_alerta_factor, row.nri_alerta_color),
                celdaNormal(row.ar_alerta_factor, row.ar_alerta_color),
                celdaNormal(row.tri_alerta_factor, row.tri_alerta_color),
                celdaNormal(row.proc_recomendado),
                celdaNormal(row.proc_aplicado),
                celdaNormal(row.pa_alerta_factor, row.pa_alerta_color),
                celdaNormal(row.calificacion_riesgo_residual),
                celdaNormal(row.rr_alerta_factor, row.rr_alerta_color),
                celdaNormal(row.arr_alerta_factor, row.arr_alerta_color),
                celdaNormal(row.trr_alerta_factor, row.trr_alerta_color),
                celdaNormal(row.aco_alerta_factor, row.aco_alerta_color),
                celdaNormal(row.justificacion),
                celdaNormal(row.comentario)
            ]);
        });
        const docDefinition = omodel.template(body, info);
        pdfMake.createPdf(docDefinition).download('Reporte_Monitoreo_Nivel_Riesgo_Perfil.pdf');
    }

    const procedimientoRecomendadoBody = (rowData) => {
        const valorActual = rowData.iproc_recomendado ?? '';
        const opcionesControlSinNull = opcionesControl.filter(opt => opt.value !== -1);
        return (<Dropdown value={valorActual} options={opcionesControlSinNull} onChange={(e) => handleSeleccionChange(e.value, rowData, 'recomendado')} placeholder="Seleccione" optionLabel="label" optionValue="value" style={{ width: '250px' }} disabled={estadoMatriz === ESTADOS.FINALIZADO} />);
    };

    const procedimientoAplicadoBody = (rowData) => {
        const valorActual = rowData.iproc_aplicado ?? '';
        const opcionesControlSinNull = opcionesControl.filter(opt => opt.value !== -1);
        return (<Dropdown value={valorActual} options={opcionesControlSinNull} onChange={(e) => handleSeleccionChange(e.value, rowData, 'aplicado')} placeholder="Seleccione" optionLabel="label" optionValue="value" style={{ width: '250px' }} disabled={estadoMatriz === ESTADOS.FINALIZADO} />);
    };

    const justificacionBody = (rowData) => {
        const valorActual = rowData.ijustificacion ?? '';
        const opcionesJustificacionSinNull = opcionesJustificacion.filter(opt => opt.value !== -1);
        return (<Dropdown value={valorActual} options={opcionesJustificacionSinNull} onChange={(e) => handleSeleccionChange(e.value, rowData, 'justificacion')} placeholder="Seleccione" optionLabel="label" optionValue="value" style={{ width: '130px' }} disabled={estadoMatriz === ESTADOS.FINALIZADO} />);
    };

    const comentarioBody = (rowData) => {
        const estaGuardando = comentarioEnEdicion === rowData.id;

        return (
            <div style={{ position: 'relative', minHeight: '40px' }}>
                {estaGuardando && (
                    <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(255, 255, 255, 0.8)', zIndex: 1 }}>
                        <ProgressSpinner style={{ width: '24px', height: '24px' }} strokeWidth="5" />
                        <span style={{ marginLeft: '8px', fontSize: '0.9rem', color: '#666' }}>
                            Guardando...
                        </span>
                    </div>
                )}
                <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', maxWidth: '100%', opacity: estaGuardando ? 0.5 : 1 }}>
                    {rowData.comentario}
                </div>
            </div>
        );
    };

    // Debe ser un array para que se renderice, caso contrario no lo hace
    const columnasDeGestion = estadoMatriz !== ESTADOS.FINALIZADO ? [
        <Column key="rowEditor" rowEditor headerStyle={{ width: '10rem' }} bodyStyle={{ textAlign: 'center' }} header="Editar" />
    ] : null;

    const cuerpoTemplates = {
        procedimientoRecomendadoBody,
        procedimientoAplicadoBody,
        justificacionBody,
        nombresBody: (rowData) => {
            return (
                <div className="flex align-items-center" style={{ marginLeft: '-0.5rem' }}>
                    <div style={{ width: '4px', height: '35px', borderRadius: '0 4px 4px 0', marginRight: '12px', transition: 'background-color 0.3s ease' }}></div>
                    <div className="flex flex-column">
                        <span className="font-bold" style={{ fontSize: '0.9rem', lineHeight: '1.1', transition: 'color 0.3s ease' }}>
                            {rowData.nombres}
                        </span>
                    </div>
                </div>
            );
        },
        comentarioBody,
    };

    const handleBulkChange = async (nuevoValor, opcion, tipoActualizacion) => {
        const idsSeleccionados = tipoActualizacion === 'visibles' ? tablaEstado.data.map(item => item.id) : []; // para 'todos' enviamos array vacío o undefined
        const camposMap = {
            recomendado: { id: 'iproc_recomendado' },
            aplicado: { id: 'iproc_aplicado' },
            justificacion: { id: 'ijustificacion' }
        };
        const campo = camposMap[opcion];
        // Optimistic update
        tablaEstado.setData(prevRegisters => {
            return prevRegisters.map(item => {
                return { ...item, [campo.id]: nuevoValor };
            });
        });
        // Las opciones deben ser 'recomendado', 'aplicado' o 'justificacion'
        const data = {
            id: tipoActualizacion === 'todos' ? 'todos' : idsSeleccionados,
            ids: nuevoValor,
            idm: matriz?.id,
            opcion: opcion,
            tipoActualizacion: tipoActualizacion
        };

        monitoreoService.editar(data, 'monitoreo/nivel-riesgo-perfil/actualizar-masivo').then(res => {
            toast.current.show({ severity: 'success', summary: 'Actualización Masiva', detail: 'Registros actualizados correctamente.', life: 3000 });
            if (opcion !== 'justificacion' && res.data) { // Si el back devuelve colores para las alertas
                tablaEstado.setData(prev => prev.map(item => {
                    const match = res.data.find(d => d.id === item.id);
                    if (match) {
                        return { ...item, pa_alerta_color: match.color, pa_alerta_factor: match.nombre };
                    }
                    return item;
                }));
            }
            setRefrescarDatosHijo(prev => prev + 1);
        }).catch(error => {
            generic.funcErrorHibrida(error, toast, setError);
        });
    };

    const handleSeleccionChange = (nuevoValor, rowData, columnaOpcion) => {
        const camposMap = {
            recomendado: { id: 'iproc_recomendado' },
            aplicado: { id: 'iproc_aplicado' },
            justificacion: { id: 'ijustificacion' }
        };

        // Mapeamos las relaciones
        const campo = camposMap[columnaOpcion];
        tablaEstado.setData(prevRegisters => {
            const updated = prevRegisters.map(item => item.id === rowData.id ? { ...item, [campo.id]: nuevoValor } : item);
            return updated;
        });
        const data = { id: rowData.id, ids: nuevoValor, idm: matriz?.id, opcion: columnaOpcion };

        monitoreoService.editar(data, 'monitoreo/nivel-riesgo-perfil/actualizar').then(res => {
            generic.funcSuccess(res, toast);
            tablaEstado.setData(prevRegisters => {
                const updated = prevRegisters.map(item => {
                    if (item.id === rowData.id) {
                        const actualizado = { ...item, [campo.id]: nuevoValor };
                        if (res.data) {
                            actualizado['pa_alerta_factor'] = res.data?.nombre;
                            actualizado['pa_alerta_color'] = res.data?.color_bg;
                        }
                        return actualizado;
                    }
                    return item;
                });
                return updated;
            });
        }).catch(error => {
            generic.funcErrorHibrida(error, toast, setError);
        });
    };

    const handleFinalizarMonitoreo = () => {
        const incompletos = tablaEstado.data.filter(r =>
            !r.iproc_aplicado || !r.iproc_recomendado || !r.ijustificacion
        );

        if (incompletos.length > 0) {
            toast.current.show({ severity: 'warn', summary: 'Campos incompletos', detail: 'Faltan procedimientos o justificaciones por seleccionar.', life: 5000 });
            return;
        }

        confirmDialog({
            group: 'finalizar-monitoreo',
            message: {
                texto: '¿Está seguro de finalizar el monitoreo? Esta acción no podrá deshacerse.',
            },
            header: 'Confirmar Finalización',
            icon: 'pi pi-exclamation-triangle'
        });
    };

    const handleVolverABorrador = () => {
        confirmDialog({
            group: 'volver-a-borrador',
            header: '¿Volver a Borrador?',
            message: {
                texto: '¿Estás seguro que deseas volver la matriz al estado BORRADOR?'
            }
        });
    };

    const finalizarMonitoreo = () => {
        setLoadingToolbar(true);
        monitoreoService.editar({ matrizId: matriz?.id, estado: ESTADOS.FINALIZADO }, 'monitoreo/nivel-riesgo-perfil/cambiar-estados').then((res) => {
            toast.current.show({ severity: 'success', summary: 'Finalizado', detail: 'El monitoreo fue finalizado exitosamente', life: 3000 });
            setEstadoMatriz(ESTADOS.FINALIZADO);
            tablaEstado.refreshRows();
        }).catch(error => {
            generic.funcErrorHibrida(error, toast, setError);
        }).finally(() => {
            setLoadingToolbar(false);
        });
    };

    const volverABorrador = () => {
        setLoadingToolbar(true);
        monitoreoService.editar({ matrizId: matriz?.id, estado: ESTADOS.BORRADOR }, 'monitoreo/nivel-riesgo-perfil/cambiar-estados').then((res) => {
            toast.current.show({ severity: 'success', summary: 'Estado cambiado', detail: 'La matriz volvió al estado BORRADOR', life: 3000 });
            setEstadoMatriz(ESTADOS.BORRADOR);
            tablaEstado.refreshRows();
        }).catch(error => {
            generic.funcErrorHibrida(error, toast, setError);
        }).finally(() => {
            setLoadingToolbar(false);
        });
    };

    const onRowEditComplete = (e) => {
        let { newData, data } = e;
        if (newData.comentario === data.comentario) {
            return;
        }
        const datos = { id: newData.id, matrizId: matriz?.id, comentario: newData.comentario };
        setComentarioEnEdicion(newData.id); monitoreoService.editar(datos, 'monitoreo/nivel-riesgo-perfil/actualizar-comentario').then((res) => {
            tablaEstado.setData(prevData => {
                return prevData.map(item =>
                    item.id === newData.id ? { ...item, ...newData } : item
                );
            });
            tablaEstado.refreshRows();
            if (toast.current) {
                toast.current.show({ severity: 'success', summary: 'Actualizado', detail: 'Comentario guardado correctamente.', life: 3000 });
            }
        }).catch((error) => {
            generic.funcErrorHibrida(error, toast, setError);
        }).finally(() => {
            setComentarioEnEdicion(null);
        });
    };

    return (
        <>
            {matriz && (
                <Card className="mb-4 pl-4 pt-0 shadow-2 border-round-2xl" style={{ height: '100%', backgroundColor: '#ffffff', borderLeft: '6px solid #30363c', }} >
                    <div className="flex justify-between items-center flex-wrap gap-5">
                        <div>
                            <h3 style={{ margin: 0, color: '#003366', fontFamily: 'Segoe UI, sans-serif' }}>
                                {matriz.nombre}
                            </h3>
                            <Tag value={matriz.codigo} severity="info" style={{ backgroundColor: '#f8f9fa', color: '#003366', marginTop: '0.25rem' }} />
                        </div>
                        <div className="flex flex-column text-right">
                            <small style={{ color: '#888' }}>Fecha de inicio</small>
                            <span style={{ color: '#003366', fontWeight: 'bold', fontSize: '1.1rem' }}>
                                {matriz.fecha_inicio}
                            </span>
                        </div>
                        <div className="flex flex-column text-right">
                            <small style={{ color: '#888' }}>Fecha de fin</small>
                            <span style={{ color: '#003366', fontWeight: 'bold', fontSize: '1.1rem' }}>
                                {matriz.fecha_fin}
                            </span>
                        </div>
                        <div className="flex flex-column pl-4">
                            <small style={{ color: '#888' }}>Detalle</small>
                            <span style={{ color: '#003366', fontWeight: 'bold', fontSize: '1.1rem' }}>
                                {matriz.detalle}
                            </span>
                        </div>
                    </div>
                </Card>
            )}
            <ConfirmDialogPersonalizado group="volver-a-borrador" icon="pi pi-refresh" onAccept={() => volverABorrador()} />
            <ConfirmDialogPersonalizado group="finalizar-monitoreo" icon="pi pi-exclamation-triangle" onAccept={() => finalizarMonitoreo()} />
            <ConfirmDialogPersonalizado group="justificacion-bulk" icon="pi pi-pen-to-square" onAccept={(message) => handleBulkChange(message.message.valores, message.message.tipo, message.message.tipoActualizacion)} />
            {loadingToolbar ? (
                <div className="mb-4 p-toolbar p-component" role="toolbar" data-pc-name="toolbar" data-pc-section="root">
                    <div className="p-toolbar-group-start p-toolbar-group-left" data-pc-section="start"></div>
                    <div className="p-toolbar-group-center" data-pc-section="center">
                        <div className="flex justify-content-center">
                            <ProgressSpinner style={{ width: '32.4px', height: '32.4px' }} strokeWidth="5" />
                        </div>
                    </div>
                    <div className="p-toolbar-group-end p-toolbar-group-right" data-pc-section="end"></div>
                </div>
            ) : (
                <Toolbar className="mb-4" start={leftTool} end={rightTool} />
            )}
            <table style={{ width: '100%', marginBottom: '0.5rem', borderCollapse: 'separate', borderSpacing: 0, textAlign: 'center', fontSize: '0.8rem', border: '1px solid #ddd', borderRadius: '8px', overflow: 'hidden', }}>
                <thead>
                    <tr style={{ backgroundColor: '#003366', color: 'white' }}>
                        <th colSpan={2} style={{ padding: '0.2rem' }}>
                            NIVEL(ES) DE RIESGO INHERENTE ACEPTADO
                        </th>
                        <th colSpan={2} style={{ padding: '0.2rem' }}>
                            NIVEL(ES) DE RIESGO RESIDUAL ACEPTADO
                        </th>
                    </tr>
                    <tr style={{ backgroundColor: '#e0e0e0', color: '#333' }}>
                        <th style={{ padding: '0.1rem' }}>APETITO</th>
                        <th style={{ padding: '0.1rem' }}>TOLERANCIA</th>
                        <th style={{ padding: '0.1rem' }}>APETITO</th>
                        <th style={{ padding: '0.1rem' }}>TOLERANCIA</th>
                    </tr>
                </thead>
                <tbody>
                    <tr style={{ backgroundColor: '#f9f9f9' }}>
                        <td style={{ fontWeight: 'bold', fontSize: '1.2rem' }}>
                            {matriz.apetito_inherente}
                        </td>
                        <td style={{ fontWeight: 'bold', fontSize: '1.2rem' }}>
                            {matriz.tolerancia_inherente}
                        </td>
                        <td style={{ fontWeight: 'bold', fontSize: '1.2rem' }}>
                            {matriz.apetito_residual}
                        </td>
                        <td style={{ fontWeight: 'bold', fontSize: '1.2rem' }}>
                            {matriz.tolerancia_residual}
                        </td>
                    </tr>
                </tbody>
            </table>
            <OverlayPanel ref={overlayRecomendado} showCloseIcon style={{ width: '280px' }} dismissable>
                <Card className="p-2">
                    <h5 className="text-center mb-3">Actualización masiva de Procedimiento Recomendado</h5>
                    <div className="mb-3">
                        <h6 className="font-medium mb-3 text-center">¿A qué registros desea aplicar el cambio?</h6>
                        <div className="flex flex-column gap-3">
                            <div className="flex align-items-center">
                                <RadioButton inputId="visibles" name="tipoActualizacion" value="visibles" onChange={(e) => setTipoActualizacion(e.value)} checked={tipoActualizacion === 'visibles'} variant="filled" />
                                <label htmlFor="visibles" className="ml-2">Registros visibles</label>
                            </div>
                            <div className="flex align-items-center">
                                <RadioButton inputId="todos" name="tipoActualizacion" value="todos" onChange={(e) => setTipoActualizacion(e.value)} checked={tipoActualizacion === 'todos'} variant="filled" />
                                <label htmlFor="todos" className="ml-2">Todos los registros</label>
                            </div>
                        </div>
                    </div>
                    <Divider />
                    <Dropdown options={opcionesControl.filter(o => o.value !== -1)} placeholder="Seleccionar recomendado" className="w-full"
                        onChange={e => {
                            const opt = opcionesControl.find(o => o.value === e.value);
                            confirmarBulkChange('recomendado', opt.label, e.value, tipoActualizacion);
                            overlayRecomendado.current.hide();
                        }}
                    />
                </Card>
            </OverlayPanel>
            <OverlayPanel ref={overlayAplicado} showCloseIcon style={{ width: '280px' }} dismissable>
                <Card className="p-2">
                    <h5 className="text-center mb-3">Actualización masiva de Procedimiento Aplicado</h5>
                    <div className="mb-3">
                        <h6 className="font-medium mb-3 text-center">¿A qué registros desea aplicar el cambio?</h6>
                        <div className="flex flex-column gap-3">
                            <div className="flex align-items-center">
                                <RadioButton inputId="visibles" name="tipoActualizacion" value="visibles" onChange={(e) => setTipoActualizacion(e.value)} checked={tipoActualizacion === 'visibles'} variant="filled" />
                                <label htmlFor="visibles" className="ml-2">Registros visibles</label>
                            </div>
                            <div className="flex align-items-center">
                                <RadioButton inputId="todos" name="tipoActualizacion" value="todos" onChange={(e) => setTipoActualizacion(e.value)} checked={tipoActualizacion === 'todos'} variant="filled" />
                                <label htmlFor="todos" className="ml-2">Todos los registros</label>
                            </div>
                        </div>
                    </div>
                    <Divider />
                    <Dropdown options={opcionesControl.filter(o => o.value !== -1)} placeholder="Seleccionar aplicado" className="w-full"
                        onChange={e => {
                            const opt = opcionesControl.find(o => o.value === e.value);
                            confirmarBulkChange('aplicado', opt.label, e.value, tipoActualizacion);
                            overlayAplicado.current.hide();
                        }}
                    />
                </Card>
            </OverlayPanel>
            <OverlayPanel ref={overlayJustifacion} showCloseIcon style={{ width: '280px' }} dismissable>
                <Card className="p-2">
                    <h5 className="text-center mb-3">Actualización masiva de Justificación</h5>
                    <div className="mb-3">
                        <h6 className="font-medium mb-3 text-center">¿A qué registros desea aplicar el cambio?</h6>
                        <div className="flex flex-column gap-3">
                            <div className="flex align-items-center">
                                <RadioButton inputId="visibles" name="tipoActualizacion" value="visibles" onChange={(e) => setTipoActualizacion(e.value)} checked={tipoActualizacion === 'visibles'} variant="filled" />
                                <label htmlFor="visibles" className="ml-2">Registros visibles</label>
                            </div>
                            <div className="flex align-items-center">
                                <RadioButton inputId="todos" name="tipoActualizacion" value="todos" onChange={(e) => setTipoActualizacion(e.value)} checked={tipoActualizacion === 'todos'} variant="filled" />
                                <label htmlFor="todos" className="ml-2">Todos los registros</label>
                            </div>
                        </div>
                    </div>
                    <Divider />
                    <Dropdown options={opcionesJustificacion.filter(o => o.value !== -1)} placeholder="Seleccionar justificación" className="w-full"
                        onChange={e => {
                            const opt = opcionesJustificacion.find(o => o.value === e.value);
                            confirmarBulkChange('justificacion', opt.label, e.value, tipoActualizacion);
                            overlayJustifacion.current.hide();
                        }}
                    />
                </Card>
            </OverlayPanel>
            <TablaDinamica
                modelo={RiesgosModelInstancia.model}
                estadoTabla={tablaEstado}
                datos={tablaEstado.data}
                totalRegistros={tablaEstado.totalRecords}
                dataKey="id"
                catalogos={catalogosTabla}
                cuerpoTemplates={cuerpoTemplates}
                // PROPS DE EXPANSIÓN
                expandedRows={expandedRows}
                onRowToggle={(e) => setExpandedRows(e.data)}
                rowExpansionTemplate={rowExpansionTemplate}
                rowClassName={(rowData) => ({ 'bg-blue-50': expandedRows && expandedRows[rowData.id] })}
                // Props edición
                acciones={columnasDeGestion}
                editMode="row"
                onRowEditComplete={onRowEditComplete}
            >
                <Column expander={(rowData) => rowData.tiene_historial === true} style={{ width: '4rem', backgroundColor: '#f8fafc', zIndex: '1' }} frozen alignFrozen="left" />
            </TablaDinamica>
        </>
    )
}


export const TablaRiesgoHistorial = ({ rowData, matriz, monitoreoService, toast, generic, setError, catalogosTabla, estadoMatriz, refreshTrigger, ESTADOS }) => {
    const RiesgosHistorialInstancia = useMemo(() => new TablaRiesgosClass({ historial: true }), []);
    const historialEstado = useLazyParams({ initialRows: 5, modelo: RiesgosHistorialInstancia.model });
    const [comentarioEnEdicion, setComentarioEnEdicion] = useState(null);

    useEffect(() => {
        // Si hay datos y la matriz padre cambio de estado, actualizamos el hijo
        if (historialEstado.data && historialEstado.data.length > 0) {
            historialEstado.refreshRows();
        }
        // eslint-disable-next-line
    }, [estadoMatriz]);

    useEffect(() => {
        if (refreshTrigger > 0) {
            historialEstado.refreshData();
        }
        // eslint-disable-next-line
    }, [refreshTrigger]);

    useEffect(() => {
        const riesgoId = rowData.riesgo_id_persona; // De la tabla riesgo_perfil_persona
        if (!riesgoId) return;

        const params = {
            ...historialEstado.lazyParams,
            matrizId: matriz.id,
            riesgoId: riesgoId
        };

        historialEstado.setLoading(true);
        monitoreoService.listado('monitoreo/nivel-riesgo-perfil/lista-matriz-historial', { lazyEvent: JSON.stringify(params) }).then(res => {
            historialEstado.setTotalRecords(res.data.total);
            historialEstado.setData(res.data.registros);
        }).catch(error => {
            generic.funcErrorHibrida(error, toast);
        }).finally(() => {
            historialEstado.setLoading(false);
        });
        // eslint-disable-next-line
    }, [historialEstado.lazyParams, rowData.id]);

    const onRowEditCompleteHistorial = (e) => {
        let { newData, data } = e;
        if (newData.comentario === data.comentario) return;

        const datos = { id: newData.id, matrizId: matriz?.id, comentario: newData.comentario };
        setComentarioEnEdicion(newData.id);

        monitoreoService.editar(datos, 'monitoreo/nivel-riesgo-perfil/actualizar-comentario').then(() => {
            historialEstado.setData(prev => prev.map(item => item.id === newData.id ? { ...item, ...newData } : item));
            historialEstado.refreshRows();
            toast.current?.show({ severity: 'success', summary: 'Actualizado', detail: 'Comentario guardado.', life: 3000 });
        }).catch((error) => {
            generic.funcErrorHibrida(error, toast, setError)

        }).finally(() => {
            setComentarioEnEdicion(null)
        });
    };

    const handleSeleccionChangeHistorial = (nuevoValor, filaHistorial, columnaOpcion) => {
        const camposMap = { recomendado: 'iproc_recomendado', aplicado: 'iproc_aplicado', justificacion: 'ijustificacion' };
        const campo = camposMap[columnaOpcion];
        // Optimistic update
        historialEstado.setData(prev => prev.map(item => item.id === filaHistorial.id ? { ...item, [campo]: nuevoValor } : item));
        const data = { id: filaHistorial.id, ids: nuevoValor, idm: matriz?.id, opcion: columnaOpcion };
        monitoreoService.editar(data, 'monitoreo/nivel-riesgo-perfil/actualizar').then(res => {
            generic.funcSuccess(res, toast);
            if (res.data) {
                const colores = { pa_alerta_factor: res.data?.nombre, pa_alerta_color: res.data?.color_bg };
                historialEstado.setData(prev => prev.map(item => item.id === filaHistorial.id ? { ...item, [campo]: nuevoValor, ...colores } : item));
            }
        }).catch((error) => {
            generic.funcErrorHibrida(error, toast, setError)
        });
    };

    const opcionesSinNull = (opciones) => opciones.filter(opt => opt.value !== -1);

    const cuerpoTemplatesHijo = {
        procedimientoRecomendadoBody: (rData) => <Dropdown value={rData.iproc_recomendado ?? ''} options={opcionesSinNull(catalogosTabla.procedimientos)} onChange={(e) => handleSeleccionChangeHistorial(e.value, rData, 'recomendado')} placeholder="Seleccione" style={{ width: '250px' }} disabled={estadoMatriz === ESTADOS.FINALIZADO} />,
        procedimientoAplicadoBody: (rData) => <Dropdown value={rData.iproc_aplicado ?? ''} options={opcionesSinNull(catalogosTabla.procedimientos)} onChange={(e) => handleSeleccionChangeHistorial(e.value, rData, 'aplicado')} placeholder="Seleccione" style={{ width: '250px' }} disabled={estadoMatriz === ESTADOS.FINALIZADO} />,
        justificacionBody: (rData) => <Dropdown value={rData.ijustificacion ?? ''} options={opcionesSinNull(catalogosTabla.justificaciones)} onChange={(e) => handleSeleccionChangeHistorial(e.value, rData, 'justificacion')} placeholder="Seleccione" style={{ width: '130px' }} disabled={estadoMatriz === ESTADOS.FINALIZADO} />,
        comentarioBody: (rData) => (
            <div style={{ position: 'relative', minHeight: '40px' }}>
                {comentarioEnEdicion === rData.id && (
                    <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(255,255,255,0.8)', zIndex: 1 }}>
                        <ProgressSpinner style={{ width: '24px', height: '24px' }} strokeWidth="5" />
                    </div>
                )}
                <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', opacity: comentarioEnEdicion === rData.id ? 0.5 : 1 }}>
                    {rData.comentario}
                </div>
            </div>
        )
    };

    const columnasDeGestion = estadoMatriz !== ESTADOS.FINALIZADO ? [<Column key="rowEditor" rowEditor headerStyle={{ width: '10rem' }} bodyStyle={{ textAlign: 'center' }} header="Editar" />] : null;

    return (
        <div style={{ backgroundColor: '#f8fafc', border: '1px solid #e2e8f0', borderLeft: '4px solid #3b82f6', borderRadius: '8px', padding: '1.5rem', margin: '0.5rem', boxShadow: 'inset 0 2px 4px 0 rgba(0, 0, 0, 0.05)' }}>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '1rem' }}>
                <i className="pi pi-history" style={{ fontSize: '1.5rem', color: '#3b82f6', marginRight: '1rem' }}></i>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <span style={{ color: '#64748b', fontSize: '0.85rem', fontWeight: '600', textTransform: 'uppercase' }}>Historial</span>
                    <span style={{ color: '#0f172a', fontSize: '1.25rem', fontWeight: 'bold' }}>{rowData.nombres}</span>
                </div>
            </div>
            <div style={{ backgroundColor: '#ffffff', borderRadius: '8px', padding: '0.5rem', border: '1px solid #e2e8f0' }}>
                <TablaDinamica modelo={RiesgosHistorialInstancia.model} estadoTabla={historialEstado} datos={historialEstado.data} totalRegistros={historialEstado.totalRecords} dataKey="id" catalogos={catalogosTabla} cuerpoTemplates={cuerpoTemplatesHijo} acciones={columnasDeGestion} editMode="row" onRowEditComplete={onRowEditCompleteHistorial} />
            </div>
        </div>
    );
};
